// packages
import { entries } from 'd3-collection';
import { intcomma } from 'journalize';
import { h } from 'preact';

// components
import CandidateRow from './CandidateRow';
import PureComponent from './PureComponent';

// internal
import formatPercent from '../utils/format-percent';

class TooltipTable extends PureComponent<any> {
  render() {
    const { candidatesMap, county, candidatesRender } = this.props;

    const sortedResults = entries(county.results).sort(
      (a, b) => b.value - a.value
    );

    

    const firstThreeResults = sortedResults.slice(0, 3);


    return (
      <div class="contest">
        <table class="contest__candidates contest__candidates--tooltip">
          <caption>
            <p class="contest__title">{county.county} County</p>
            <div class="contest__metrics">
              <p class="contest__precincts">
                {`${formatPercent(
                  county.county_pollinglocationsreporting,
                  county.total_county_pollinglocations
                )}% reporting`}
              </p>
            </div>
          </caption>
          {CandidateRow.countyHeader}
          <tbody>
            {firstThreeResults.map(result => {
              const candidate = candidatesMap.get(result.key);

              const candColor = candidatesRender.filter(cand => cand.id  == candidate.id);

              return (
                <CandidateRow
                  key={candidate.id}
                  ballotName={candidate.name}
                  candidateId={candidate.id}
                  contestIsCalled={false}
                  candidateColor={candColor[0]['color']}
                  isIncumbent={candidate.is_incumbent}
                  isWinner={candidate.is_winner}
                  party={candidate.party}
                  totalVotesInContest={county.total_votes}
                  votes={result.value}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TooltipTable;
